import React from 'react';

import Utils from 'utils/Utils.js';
import { translate, Trans } from 'react-i18next';
import {colors, spacings, fontSizes, fonts} from 'style';

const style = {
    content: {
        ...fonts.body,
        lineHeight: '1.5',
        paddingBottom: spacings.small,
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '40rem',
    },
}

const Instructions = ({challenge}) => (
    <div style={style.content}>
        {Utils.endlToBr(challenge.description)}
    </div>
);

export default translate("challenges")(Instructions);



// WEBPACK FOOTER //
// ./src/modules/challenges/types/Instructions.js